import PropTypes from 'prop-types';

import { ReactSelectAsyncWithAxios } from '@hivebrite/design-system/Inputs';

const noOptionsMessage = ({ inputValue }) =>
  inputValue
    ? __('School %{school} not found').i__({
        school: inputValue,
      })
    : __('Search for a school');

const ReactSelectSchools = ({
  placeholder,
  isMulti,
  multiple,
  ...otherProps
}) => (
  <ReactSelectAsyncWithAxios
    {...otherProps}
    multiple={multiple || isMulti}
    loadOptionsUrl={Routes.search_schools_path({ format: 'json' })}
    placeholder={placeholder || __('School')}
    noOptionsMessage={noOptionsMessage}
  />
);

ReactSelectSchools.propTypes = {
  placeholder: PropTypes.string,
};

export default ReactSelectSchools;
